<div>
    <div class="cover-photo" style="position: relative; z-index: 3; left: 0; right: 0; height: 200px;">
    </div>

    <div class="extra-light-grey-cfa-languedoc-bg" style="position: relative; z-index: 10;">

        <div class="container white-bg pt-3 px-1-on-small">

            <div style="margin-left: -15px; margin-top: -110px !important; position: absolute; z-index: 12;">
                <h1 class="col-12 p-2 bandeau-title blue-cfa-languedoc-bg white font-weight-bold" style="display: table">Centre de Formation du Languedoc</h1>
                <h2 class="col-12 p-2 bandeau-subtitle grey-cfa-languedoc-bg white font-weight-bold">Soutien scolaire d'excellence</h2>
            </div>

            <div class="p-3 mt-2 px-0-on-small min-size">

                <h1 style="font-size: 30px" class="col-12 blue-cfa-languedoc text-center">Prise de contact</h1>
                
                <div *ngIf="formAnswer && formAnswer.database">
                    <p class="mt-2">Votre demande a bien été prise en compte, nous vous en remercions.<br>
                    Vous serez prochainement contacté(e) par le Centre de Formation du Languedoc.<br>
                    D’ici là, nous restons à votre disposition au <a href="tel:0467527079">04 67 52 70 79</a> ou par mail à <a href="mailto:contact@apprentissage-montpellier.education">contact@apprentissage-montpellier.education</a></p>
                        
                    <div class="row" *ngIf="!isLoadingBrochures && brochure && brochure.prepa && brochure.prepa.length>0">
                        <p class="col-12 mb-0">Vous pouvez également télécharger nos notices:</p>
                        <div class="col-12 col-md-6 px-2">
                            <div *ngFor="let brochure of brochure.prepa">
                                <a [href]="'https://www.apprentissage-montpellier.education/brochures/' + brochure.lien_brochure" target="_blank">{{brochure.titre_produit}} - {{brochure.nom_instance}}</a>
                            </div>
                        </div>
                    </div>  
                </div>
                
                <div *ngIf="!formAnswer">
                    
                    <form>

                        <h5 class="col-12 form-title yellow-bg mb-0 mt-4">Écrivez-nous !</h5>
        
                        <div class="row px-5 py-1">
                            <div class="col-12 col-sm-2 col-md-3 col-lg-2">
                                Vous êtes :
                            </div>
                            <div class="col-12 col-sm-10 col-md-9">
                                <select name="identite" [(ngModel)]="generalContactForm.identite" class="white-bg green-border" required id="identite">
                                    <option value="" selected>Veuillez faire un choix svp</option>
                                    <option value="Employeur potentiel">Employeur potentiel</option>
                                    <option value="Etudiant ou Lycéan">Etudiant ou Lycéen</option>
                                    <option value="Formateur">Formateur</option>
                                    <option value="Autre">Autre</option>
                                </select>                          
                            </div>
                        </div>
    
                        <div class="row px-5 py-1">
                            <div class="col-12">
                                Message
                            </div>
                            <div class="col-12">      
                                <textarea name="message" id="message" [(ngModel)]="generalContactForm.message" type="text" class="white-bg green-border col-12" required></textarea>                       
                            </div>
                        </div>


                        <h5 class="col-12 form-title green-bg mb-0 mt-4">Coordonnées</h5>

                        <div class="row px-5 py-1">
                            <div class="col-12 col-sm-3 col-md-3 col-lg-2">
                                Téléphone
                            </div>
                            <div class="col-12 col-sm-9 col-md-9">
                                <input name="tel" id="tel" minlength="10" maxlength="15" [(ngModel)]="generalContactForm.telephone" type="text" class="white-bg green-border" required (blur)="verifTel($event)">
                            </div>
                        </div>

                        <div class="row px-5 py-1">
                            <div class="col-12 col-sm-3 col-md-3 col-lg-2">
                                Mail
                            </div>
                            <div class="col-12 col-sm-9 col-md-9">
                                <input name="email" id="email" maxlength="20" [(ngModel)]="generalContactForm.mail" type="email" maxlength="40" class="white-bg green-border" (blur)="verifMail($event)" required>
                            </div>
                        </div>

                        <div *ngIf="error" class="row px-5">
                            <p class="red-cfa-languedoc ml-auto pb-0 pt-1 mb-0">{{error}}</p>
                        </div>
                        <div *ngIf="isSendingForm" class="text-center">
                            <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                            <span>Envoi du formulaire...</span>
                        </div>
                        <div id="submit" class="row px-5">
                            <div class="ml-auto">
                                <input name="envoie" type="button" (click)="verifForm()" value="Envoyer" class="blue-cfa-languedoc-bg bouton-submit col-xs-5 px-3 my-3">
                            </div>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    </div>
</div>